// extracted by mini-css-extract-plugin
module.exports = {"switch_container":"SwitchWithLabel_switch_container__1B4aX","switch_text":"SwitchWithLabel_switch_text__HPVwd"};